<div class="modal-header">
	<h2 class="modal-title" [innerHtml]="pageTitle"></h2>
	<button type="button" class="btn btn-close" aria-label="Close" (click)="close()" data-cy="CloseButton">
		<i class="fal fa-xmark"></i>
	</button>
</div>

<div class="modal-body">
	<rl-form-table-row [labelText]="'Rule Set Name'" [required]="true">
		<ng-template rlFormTableControl>
			<rl-text-input [formControl]="form.controls.name" [placeholder]="'Enter Name'"
				[dataLabel]="'ruleSetNameInput'">
			</rl-text-input>
			@if (form.controls.name.errors?.duplicateName && form.controls.name.dirty) {
				<div class="text-danger small mt-1" data-cy="DuplicateRuleSetNameError">
					A Rule Set with this name already exists on this Account Group.
				</div>
			}
		</ng-template>
	</rl-form-table-row>
	<rl-form-table-row [labelText]="'Account'" [required]="true">
		<ng-template rlFormTableControl>
			<rl-dropdown-single [formControl]="form.controls.account" [options]="accountOptions"
				[showEmptyOption]="true" [placeholder]="'Select'" [dataLabel]="'RuleSetAccountDropdown'">
			</rl-dropdown-single>
		</ng-template>
	</rl-form-table-row>
</div>

<div class="modal-footer">
	<button type="button" class="btn btn-light ms-auto" (click)="close()" data-cy="CancelButton">
		Cancel
	</button>
	<button (click)="save()" class="btn btn-success" [disabled]="!form?.valid || form?.pristine" data-cy="SaveButton">
		Save
	</button>
</div>
